export default class UtilHtmlInjectLoader {
    constructor() {
        let selector = '[data-inject]';
        let elements = document.querySelectorAll(selector);
        for (var i = 0; i < elements.length; i++) {
            let endpoint = elements[i].getAttribute('data-endpoint');
            let callback = elements[i].getAttribute('data-callback');
            this.loadAndReplace(endpoint, elements[i], callback);
        }
    }

    loadAndReplace(endpoint, element, callback) {
        let self = this;
        const req = new XMLHttpRequest();
        req.addEventListener("load", function() {
            self.reqListener(this, element, callback);
        });
        req.open("GET", endpoint);
        req.send();
    }

    reqListener(req, element, callback) {
        if(req.responseText.replace(/\s+/gim, '') != '') {
            element.replaceWith(this.createElementFromHTML(req.responseText));
            this.performCallback(callback);
        }
    }
    
    createElementFromHTML(htmlString) {
        let div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstChild;
    }
    
    performCallback(callback) {
        if (typeof callback !== 'undefined') {
            if(typeof window[callback] === 'function') {
                window[callback].call();
                return;
            }
        }   
    }
}